module.exports = {
  siteTitle: 'Febrian Kurniawan',
  siteDescription:
    'Febrian Kurniawan is a curiosity-driven engineer, based in Indonesia, currently looking for collaboration.',
  siteKeywords:
    'Febrian Kurniawan, Febrian, Kurniawan, febriankurniawan, software engineer, web developer, cyber security, python, cloud, malware, telkom university',
  siteUrl: 'https://linkedin.com/in/febriankurniawan',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Febrian Kurniawan',
  location: 'Jakarta, Indonesia',
  email: 'febrian@ieee.org',
  // github: 'https://github.com/yashitanamdeo',
  // twitterHandle: '@',
  socialMedia: [
    // {
    //   name: 'GitHub',
    //   url: 'https://github.com/yashitanamdeo',
    // },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/febrian-kurniawan',
    },
    // {
    //   name: 'Codepen',
    //   url: 'https://codepen.io/yashitanamdeo',
    // },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/febrian_k_',
    },
    // {
    //   name: 'Twitter',
    //   url: 'https://twitter.com/',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Contracts & Part-Time',
      url: '/#contracts',
    },
    {
      name: 'Collaborations',
      url: '/#collaborations',
    },
    
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
